<script lang="ts" setup>
  import { computed } from 'vue';
  import type { PlayerChoosingView } from '../../../../shared/api/round.ts';
  import type { Song } from '../../../../shared/api/song.ts';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import SongSearch from '../song/SongSearch.vue';
  import RoundHeader from './RoundHeader.vue';

  const props = defineProps<{
    data: PlayerChoosingView;
    secondsLeft: string;
    isHost: boolean;
    songs: Song[];
    isLoading: boolean;
    error: string;
    searchError?: string;
  }>();
  defineEmits<{ search: [query: string]; chosenSong: [song: Song] }>();
  const songSearchQuery = defineModel<string>();

  const targetRange = computed(() => {
    const { fewest, most } = props.data.targetRange;
    return fewest === most ? `${fewest}` : `${fewest}–${most}`;
  });
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <SongSearch
      v-model="songSearchQuery"
      :disabled="data.paused"
      :is-loading="isLoading"
      :search-error="searchError"
      :songs="songs"
      loading-label="Choosing song…"
      placeholder="Choose song"
      @song-selected="$emit('chosenSong', $event)"
    >
      <p v-if="data.targetRange.most > 0" class="scoring-hint">
        Choose a song you think {{ targetRange }} {{ targetRange === '1' ? 'player' : 'players' }} will guess correctly
      </p>
      <p v-if="error" class="error">{{ error }}</p>
    </SongSearch>
  </MobileViewLayout>
</template>

<style scoped>
  .scoring-hint {
    color: var(--color-primary);
    font-size: var(--font-size-sm);
    letter-spacing: 0.05em;
    margin: 0 0 0.5rem;
    text-align: center;
    text-transform: uppercase;
  }

  .error {
    color: var(--color-error);
    margin: 0 0 0.25rem;
    text-align: center;
  }
</style>
